import drawnStars from "@/../../hypetrain/static/img/drawn-stars.png";
import execDrawnStars from "@/../../hypetrain/static/img/exec-drawn-stars.png";
import { Box } from "@/components/layout/flexbox";
import { WhiteBar } from "@/components/pieces/marketing/WhiteBar";
import { SITE_NAME } from "@/css/constants";

export function HighSatisfaction() {
  return (
    <WhiteBar fontSize={20} textAlign="center">
      <img
        src={IS_EXEC ? execDrawnStars : drawnStars}
        style={{ maxWidth: "100%" }}
        className="inline-block"
      />
      <Box mt={24}>
        Regardless of job title, experience, or location, {SITE_NAME} has you
        covered.
        <br />
        Our 100% remote coaching experience has 99% satisfaction.
      </Box>
    </WhiteBar>
  );
}
